export default __webpack_public_path__ + "static/media/jackPrize.7d6540b2.png";